module.exports = __webpack_public_path__ + "1fab86391b8f66d58a3a5ca4e26b156d.jpg";